import React, { useEffect, useState } from "react";
import doc from "../../../images/google-docs.png";
import imgPdf from "../../../images/pdf.png";
import { Col, Card, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getVerfiedViewByID } from "../../../services/adminApiService/verifiedlistApiService/VerifiedLIstApiService";
import { formatLable } from "../../../utils/colorAsperStatus";
import {
  getCityFromId,
  getCountryFromId,
  getStateFromId,
} from "../../../utils/CountryConveter";
import { doclabelMap } from "../organization/DocLable";

const InsituteViewUser = () => {
  const { id } = useParams();
  const [individualverifyData, setIndividualverifyData] = useState({});
  const [insituteVerifyList, setInsituteVerifyList] = useState([]);

  useEffect(() => {
    const fetchVerifiedDetailsList = async (typeId) => {
      try {
        const response = await getVerfiedViewByID(typeId, id);
        setIndividualverifyData(response?.data?.data);
      } catch (error) {
        console.error("Error fetching verification list:", error);
      }
    };

    fetchVerifiedDetailsList(2);
  }, [id]);

  const isValidUrl = (string) => {
    console.log("string", string);
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const fetchCountryName = async () => {
    if (Object.keys(individualverifyData).length > 0) {
      const countryName = await getCountryFromId(
        individualverifyData?.organization?.country
      );
      const stateName = await getStateFromId(
        individualverifyData?.organization?.country,
        individualverifyData?.organization?.state
      );
      const cityName = await getCityFromId(
        individualverifyData?.organization?.state,
        individualverifyData?.organization?.city
      );

      const baseList = [
        {
          id: 1,
          label: "Institution Name",
          value: individualverifyData?.name_of_legel_entity,
        },
        {
          id: 2,
          label: "Registration Number",
          value: individualverifyData?.organization?.registration_number,
        },
        {
          id: 3,
          label: "Date of Establishment",
          value: individualverifyData?.organization?.year_of_operation,
        },
        {
          id: 4,
          label: "Type of Sports Institution",
          value: individualverifyData?.organization?.type_of_sports_institution,
        },
        { id: 5, label: "Country", value: individualverifyData?.organization?.country_name },
        { id: 6, label: "State/UT", value: individualverifyData?.organization?.state_name },
        { id: 7, label: "District/City", value: individualverifyData?.organization?.city_name },
        {
          id: 8,
          label: "Pincode",
          value: individualverifyData?.organization?.pincode,
        },
        {
          id: 9,
          label: "Contact Person Name",
          value: individualverifyData?.organization?.contact_person_name,
        },
        {
          id: 10,
          label: "Contact Person Mobile Number",
          value: individualverifyData?.organization?.contact_person_contact,
        },
        {
          id: 11,
          label: "Contact Person Email",
          value: individualverifyData?.organization?.contact_person_email,
        },
        {
          id: 12,
          label: "Contact Person Designation",
          value: individualverifyData?.organization?.contact_person_designation,
        },
        {
          id: 13,
          label: "Official Website",
          value: individualverifyData?.organization?.website,
        },
        {
          id: 14,
          label: "Name of Representative",
          value: individualverifyData?.organization?.represntive_name,
        },
        {
          id: 15,
          label: "Official Mobile Number",
          value: individualverifyData?.organization?.mobile,
        },
        {
          id: 16,
          label: "Official Email Address",
          value: individualverifyData?.organization?.email,
        },
        {
          id: 17,
          label: "Registered Address",
          value: individualverifyData?.organization?.address,
        },
        {
          id: 18,
          label: "Sports Offered",
          value: individualverifyData?.organization?.sports_offered,
        },
        {
          id: 19,
          label: "Facilities Available",
          value: individualverifyData?.organization?.facilities,
        },
        {
          id: 20,
          label: "Achievements",
          value: individualverifyData?.organization?.achievements,
        },
        {
          id: 21,
          label: "Affiliated Sports Bodies/Organizations",
          value: individualverifyData?.organization?.affiliated_sport_body,
        },
        {
          id: 22,
          label: "Facilities Available",
          value: individualverifyData?.organization?.amenities,
        },
        // {
        //   id: 23,
        //   label: "Other Amenities",
        //   value: individualverifyData?.organization?.other_amenities,
        // },
        { id: 23, label: "Atom Id", value: individualverifyData?.atom_id },
        { id: 24, label: "User Type", value: individualverifyData?.user_type },
        
      ];


      if (
        individualverifyData.organization_docs &&
        Array.isArray(individualverifyData.organization_docs)
      ) {
        individualverifyData.organization_docs.forEach((doc, index) => {
          const mappedLabel = doclabelMap[doc.doc_name] || doc.doc_name;
          baseList.push({
            id: 25 + index, // Assuming the IDs continue sequentially
            label: mappedLabel,
            value: doc.doc_file, // Assuming you want to display the file or use doc_name
            // key: `registration_doc_${index + 1}`,
            // action: false,
            // remark: storedRemarks[23 + index] || ""
          });
        });
      }

      setInsituteVerifyList(baseList);
    }
  };
  useEffect(() => {
    fetchCountryName();
  }, [individualverifyData, id]);
  return (
    <>
      <div className="row px-3">
        <Col lg={12} className="mb-3">
          <Card className="mb-3" style={{ height: "auto" }}>
            <Card.Header>
              <Card.Title className="text-danger">VERIFIED DETAILS</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Form Fields</th>
                    <th>Form Data</th>
                  </tr>
                </thead>
                <tbody>
                  {insituteVerifyList
                    .filter((data) => data.value)
                    .map((data, index) => (
                      <tr key={data.id}>
                        <td>{index + 1}</td>
                        <td>
                          <span style={{ color: "#886CC0" }}>
                            <strong>{formatLable(data?.label)}</strong>
                          </span>
                          <br />
                        </td>
                        <td>
                          {isValidUrl(data.value) ? (
                            <div>
                              {/* Check if it's a document (PDF, DOC) */}
                              {data.value.includes(".pdf") ? (
                                <>
                                  <img
                                    src={imgPdf}
                                    alt={data.label}
                                    style={{ maxWidth: "100px", height: "auto" }}
                                  />
                                  <a
                                    href={data.value}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text_view mx-1"
                                  >
                                    View file
                                  </a>
                                </>
                              ) : data.value.includes(".doc") ? (
                                <>
                                  <img
                                    src={doc}
                                    alt={data.label}
                                    style={{ maxWidth: "100px", height: "auto" }}
                                  />
                                  <a
                                    href={data.value}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text_view mx-1"
                                  >
                                    View file
                                  </a>

                                </>
                              ) : data.value.match(/\.(jpeg|jpg|gif|png)$/) ? (
                                // Check if it's an image (show image + View file)
                                <>
                                  <img
                                    src={data.value}
                                    alt={data.label}
                                    style={{ maxWidth: "100px", height: "auto" }}
                                  />
                                  <a
                                    href={data.value}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text_view mx-1"
                                  >
                                    View file
                                  </a>
                                </>
                              ) : (
                                // If it's a website URL, show as a link only (without "View file")
                                <a
                                  href={data?.value}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "blue", textDecoration: "underline" }}
                                >
                                  {data?.value}
                                </a>
                              )}
                            </div>
                          ) : (
                            <span className="" style={{ fontSize: "13px" }}>
                              {data?.value
                                .split(", ")
                                .filter((item) => item.trim() !== "Others")
                                .join(", ")}
                            </span>

                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>

              </Table>
            </Card.Body>
          </Card>
        </Col>
      </div>
    </>
  );
};

export default InsituteViewUser;
